import styled from 'styled-components';

const Wrapper = styled.div<{ $color?: string; }>`

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.outline};
  border-radius: 12px;
  flex: 1;
  padding: 8px 16px;

  font-size: 13px;

  .title {
    margin-bottom: 8px;
    color: ${(props) => props.$color};
  }

  .label {
    color: ${(props) => props.theme.colors.inactive};
  }
`;

export default { Wrapper };
